const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      '& em': {
        position: 'relative',
        zIndex: 2,
        userSelect: 'none',
        transition: 'color 0.5s ease-out',
        display: 'inline-flex',
        cursor: 'text',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: 2,
          backgroundColor: 'currentColor',
          transition: 'all 0.5s ease-out',
        },
      },
    },
    imageContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '20vw',
      opacity: (props) => (props.isIE11 ? 0 : 0.5),
      clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
      '-webkit-clip-path': 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: theme.colors[4],
      },
    },
    image: {
      position: 'relative',
      maxWidth: 'inherit',
      verticalAlign: 'middle',
      opacity: 0,
      zIndex: 1,
      transform: 'scale(1.5)',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      '& em': {
        '&::after': {
          content: 'none',
        },
      },
    },
    imageContainer: {
      transform: 'translate(-50%, -50%) scale(0.5)',
    },
  }

  return output
}

export default style
